var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0061 2.00836C19.6754 2.07467 23.1719 3.57881 25.7433 6.1971C28.3147 8.8154 29.7554 12.3385 29.7554 16.0084C29.7554 19.6782 28.3147 23.2013 25.7433 25.8196C23.1719 28.4379 19.6754 29.9421 16.0061 30.0084C12.3369 29.9421 8.84037 28.4379 6.26896 25.8196C3.69756 23.2013 2.25684 19.6782 2.25684 16.0084C2.25684 12.3385 3.69756 8.8154 6.26896 6.1971C8.84037 3.57881 12.3369 2.07467 16.0061 2.00836ZM13.0987 20.5562L9.67013 17.1246C9.38948 16.8429 9.2319 16.4616 9.2319 16.064C9.2319 15.6664 9.38948 15.285 9.67013 15.0034C9.9522 14.723 10.3338 14.5657 10.7315 14.5657C11.1292 14.5657 11.5107 14.723 11.7928 15.0034L14.208 17.4217L20.2195 11.4103C20.5011 11.1296 20.8825 10.972 21.28 10.972C21.6776 10.972 22.059 11.1296 22.3406 11.4103C22.6209 11.6921 22.7782 12.0734 22.7782 12.4708C22.7782 12.8683 22.6209 13.2496 22.3406 13.5314L15.2671 20.6049C15.1235 20.7478 14.9525 20.8602 14.7644 20.9353C14.5763 21.0105 14.375 21.0469 14.1725 21.0423C13.97 21.0378 13.7705 20.9924 13.586 20.9088C13.4015 20.8253 13.2357 20.7053 13.0987 20.5562Z",
    fill: "#04BA96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.7d626a2b8f0c60ddbb8b4aa26bec0469.svg";
export { ForwardRef as ReactComponent };